
import type { Product } from './types';

export const miscProducts: Product[] = [
  {
    id: 'msc10',
    shopId: '',
    name: 'Brake Fluid DOT 3',
    brand: 'Generic',
    price: 15,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/4/5/4515436052f6752ed857df8056bbcbffef6b11de_3090_Bremsfl__ssigkeit_DOT_3_250ml_69ae.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal', // updated
    description: 'Standard Brake Fluid DOT 3 for automotive braking systems.',
    category: 'brake fluid',
  },
  {
    id: 'caldini1',
    shopId: '',
    name: 'CALDINI CARBON CLEAR CONTRIBUTION OF DIESEL FUEL',
    brand: 'CALDINI',
    price: 50,
    image: 'https://www.caldini.com.ro/En/assets/img/product/katki2.png', // updated image
    description: 'Diesel fuel system cleaner by CALDINI.',
    category: 'additive',
  },
  {
    id: 'caldini2',
    shopId: '',
    name: 'CALDINI CARBON CLEAR CONTRIBUTION OF GASOLINE FUEL',
    brand: 'CALDINI',
    price: 50,
    image: 'https://www.caldini.com.ro/En/assets/img/product/katki3.png', // updated image
    description: 'Gasoline fuel system cleaner by CALDINI.',
    category: 'additive',
  },
  {
    id: 'proficar-ultra-gasoline',
    shopId: '',
    name: 'PROFI-CAR ULTRA PROTECT 5 gasoline, 250 ml',
    brand: 'PROFI-CAR',
    price: 70,
    image: 'https://www.profi-car.com/files/public/ultra-protect-5-bezin-d6baf.png?1593171749', // updated image
    description: 'Gasoline additive by PROFI-CAR.',
    category: 'additive',
  },
  {
    id: 'proficar-ultra-diesel',
    shopId: '',
    name: 'PROFI-CAR ULTRA PROTECT 5 Diesel, 250 ml',
    brand: 'PROFI-CAR',
    price: 70,
    image: 'https://www.profi-car.com/files/public/label-60062-ultra-protect-5-diesel-250ml-2025-03-31-v1-aa1e8_1295.png?1747833030', // updated image
    description: 'Diesel additive by PROFI-CAR.',
    category: 'additive',
  },
  {
    id: 'diesel-engine-cleaner',
    shopId: '',
    name: 'Diesel Engine System Cleaner',
    brand: 'Generic',
    price: 50,
    image: 'https://liquimoly.cloudimg.io/v7/https://www.liqui-moly.com/media/catalog/product/cache/7c4066dd86a6b9217681a7aaaa67e822/8/c/8c037d514f3f743713cb4738b17d1af8d0cbc679_21623_Motorsystemreiniger_Diesel_300ml_a0eb.png?w=547.5&h=540&func=bound&sharp=1&org_if_sml=1&force_format=webp%252Coriginal', // updated image
    description: 'Cleaner for diesel engine systems.',
    category: 'additive',
  },
];
